import { Button } from "@/components/ui/button";
import { Headphones, BookOpen } from "lucide-react";
import heroBg from "@/assets/hero-bg.jpg";

export function Hero() {
  return (
    <section id="hero" className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={heroBg} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-hero-gradient opacity-80" />
      </div>

      <div className="relative z-10 container mx-auto px-4 text-center max-w-3xl py-32">
        <div className="inline-flex items-center gap-2 bg-primary-foreground/10 border border-primary-foreground/20 rounded-full px-4 py-1.5 mb-6">
          <Headphones className="h-4 w-4 text-accent-gold" />
          <span className="text-sm text-primary-foreground/90 font-body">Audiolibros y libros cristianos</span>
        </div>

        <h1 className="text-4xl md:text-6xl font-heading font-bold text-primary-foreground leading-tight mb-6 animate-fade-in-up">
          Tu camino espiritual,{" "}
          <span className="text-gradient-gold">un capítulo a la vez</span>
        </h1>

        <p className="text-lg md:text-xl text-primary-foreground/80 font-body mb-10 max-w-2xl mx-auto leading-relaxed">
          Escucha los grandes clásicos de la fe cristiana mientras caminas, trabajas o descansas.
          También disponible en formato PDF.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            variant="hero"
            size="lg"
            className="text-base px-8 bg-accent-gold text-accent-gold-foreground border border-accent-gold/80 hover:bg-accent-gold/90 shadow-xl"
          >
            <Headphones className="h-5 w-5 mr-2" />
            Explorar audiolibros
          </Button>
          <Button variant="heroOutline" size="lg" className="text-base px-8 bg-primary-foreground/5">
            <BookOpen className="h-5 w-5 mr-2" />
            Ver catálogo PDF
          </Button>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 text-primary-foreground/60 text-sm font-body">
          <span>+18 títulos</span>
          <span className="h-4 w-px bg-primary-foreground/20" />
          <span>Narración profesional</span>
          <span className="h-4 w-px bg-primary-foreground/20" />
          <span>Gratis para comenzar</span>
        </div>
      </div>
    </section>
  );
}
